export default {
    //是否特殊登录跳转 ahold 删除
    SPECIAL_SIGNIN: false,

    //空字符串为无特殊登录，开启特殊登陆填写对应SIGNIN_MAP中对应键名
    SIGN_TYPE: '',
    SIGNIN_MAP: {
        MI: 'miSignIn',
        KEYCLOAK: 'kcSignIn',
        SAML: 'samlSignIn'
    },

    //接口项目名
    API_PROJECTNAME: '/prismart',

    //rsa公钥
    RSA_PUBLICKEY: 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCHoZEvz7DhUarNVoSsUdUdcoc7nwcBprnwzEeka+/m/uYCFNHvQZx6cjaWtNSDmr9SDZhg/kOc1aVGaVxpeR58K9hcC3dTgVLujLH3yrhE0nhLyyq0pfJZBFR3VnK7WYq+kyd+NFn1Y9jfJyOiVWivZ78KrwvPmT9AvLLoxaOuMQIDAQAB',

    //是否显示门店名    ahold
    SHOW_STORENAME: true,

    //商品信息页是否开启具体查询
    exactSearch: false,

    //ipv6配置
    storeIpv6Show: false,

    //客户监控表格是否可见
    showMonitorBtn: false,
    //客户监控表格是否可用
    enableMonitorBtn: true,

    //商品ean查询sku/对接记录-ean对接历史   澳洲定制  config不显示
    eanEnable: false,

    //商品配置存储image-base64字段
    goodsImageField: '', //例rsrvBlob
    goodsImageSize: 100,//100为kb MB为 num*1024

    //地图文件大小限制
    mapImageSize: 5 * 1024,

    //epd价签点击图片查看详情
    eslShowDetialCarousel: true,

    //epd价签点击预览为平铺
    eslImageTiledDisplay: false,

    //客户定制语言
    custLanguageObj: {
        // customerCode: {
        //     "zh-cn": 'customerCodezhcn'
        // }
    },

    //导出低电报表   delhaize
    exportLowBattery: false,
    //闪灯时长范围
    flashTimeMax: 3600,//单位秒
    //切页策略选项
    switchPageOption: {
        pageMaxTime: 18000,//切页时长范围 单位s
        times: {
            'EPD': [
                {
                    value: 0,
                    label: '30 min',
                    minute: 30
                },
                {
                    value: 1,
                    label: '60 min',
                    minute: 60
                },
                {
                    value: 2,
                    label: '120 min',
                    minute: 120
                },
                {
                    value: 3,
                    label: '240 min',
                    minute: 240
                }
            ],
            'LCD': [
                {
                    value: 0,
                    label: '15 min',
                    minute: 15
                },
                {
                    value: 1,
                    label: '30 min',
                    minute: 30
                },
                {
                    value: 2,
                    label: '45 min',
                    minute: 45
                },
                {
                    value: 3,
                    label: '60 min',
                    minute: 60
                }
            ]
        },
        pages: [
            {
                value: 0,
                label: 'page 1'
            },
            {
                value: 1,
                label: 'page 2'
            },
            {
                value: 2,
                label: 'page 3'
            },
            {
                value: 3,
                label: 'page 4'
            },
            {
                value: 4,
                label: 'page 5'
            },
            {
                value: 5,
                label: 'page 6'
            },
            {
                value: 6,
                label: 'page 7'
            },
            {
                value: 7,
                label: 'page 8'
            }
        ]
    },

    //任务选择
    taskTimeOption: {
        ruleType: ['ONCE', 'DAILY', 'WEEKLY', 'MANUAL'],
        week: [1, 2, 3, 4, 5, 6, 0],
        ledColor: ['red', 'green', 'blue'],
        // ledColor: ['red', 'green', 'blue', 'violet', 'indigo', 'white', 'yellow']
    },
    //任务商品限制条数
    taskFilterLimit: 3,

    goodsView: {
        fields: {
            numbers: [
                'level1CategoryCode',
                'level2CategoryCode',
                'level3CategoryCode',
                'level4CategoryCode',
                'level5CategoryCode',
                'price1',
                'price2',
                'price3',
                'price4',
                'price5',
                'price6',
                'promoFlag',
                'inventory',
                'safetyStock',
                'dms',
                'todaySalesQty',
                'cumulatedSalesQty',
                'shelfQty',
                'onOrderQty',
                'shelfLife',
                'memberPoNUMBERs',
                'memberPoints',
                'rsrvDec1',
                'rsrvDec2',
                'rsrvDec3',
                'rsrvDec4',
                'rsrvDec5',
                'rsrvDec6',
                'rsrvDec7',
                'rsrvDec8',
                'rsrvDec9',
                'rsrvDec10',
                'rsrvDec11',
                'rsrvDec12',
                'rsrvDec13',
                'rsrvDec14',
                'rsrvDec15',
                'rsrvDec16',
                'rsrvDec17',
                'rsrvDec18',
                'rsrvDec19',
                'rsrvDec20',
                'rsrvDec21',
                'rsrvDec22',
                'rsrvDec23',
                'rsrvDec24',
                'rsrvDec25',
                'rsrvInt1',
                'rsrvInt2',
                'rsrvInt3',
                'rsrvInt4',
                'rsrvInt5',
                'rsrvInt6',
                'rsrvInt7',
                'rsrvInt8',
                'rsrvInt9',
                'rsrvInt10',
                'rsrvInt11',
                'rsrvInt12',
                'rsrvInt13',
                'rsrvInt14',
                'rsrvInt15',
                'rsrvInt16',
                'rsrvInt17',
                'rsrvInt18',
                'rsrvInt19',
                'rsrvInt20',
                'rsrvInt21',
                'rsrvInt22',
                'rsrvInt23',
                'rsrvInt24',
                'rsrvInt25',
            ],
            date: [
                'expiryDate',
            ],
            dateTime: [
                'promoDateFrom',
                'promoDateTo',
                'vipDateFrom',
                'vipDateTo',
                'createDate',
                'updateDate'
            ],
            time: [
                'promoTimeFrom',
                'promoTimeTo',
                'vipTimeFrom',
                'vipTimeTo'
            ]
        },
        notShow: ['customerCode', 'storeCode', 'sku', 'template', 'status']
    },

    //gitlabVersion字段配置为空或者不配置就不会显示  bela
    gitlabVersion: '',

    //退出保留登录ID功能开关  bela
    reserveUserId: false,

    //门店统计时长设置  france
    latelyHeartbeatEslTime: 72,
    latelyUpdateEslTime: 24,
    latelyBoundEslTime: 24,

    //是否显示价签电压列
    showVoltage: false,

    //月度报表esl配置 metro
    monthlyStatisticEslgetType: ['eslOffline', 'eslFailure', 'commError', 'timeout', 'apOffline'],//同bindingStateOption value
    monthlyStatisticEsldownloadType: [],

    //跳转监控外链  国美
    linkMonitorUrl: "",

    //邮件预警空闲时间显示控制
    showMaillFreePeriods: false,
    //绑定信息页默认页搜索条件  wow
    showSearchDefaultpage: false,


    //监控表格是否自动翻页  国美
    monitorTablePageTimerSwitch: true,

    //切页任务 屏幕类型
    pageTaskScreenTypeShow: false,

    //按ap切页开关  乐华梅林
    showSwitchPageTaskByAp: false,

    //批次号@换行
    wrapCdiBatchNo: false,


    //输入内容长度限制
    conMaxLength: 128,
    //输入内容长度限制大
    conMaxLengthBig: 255,

    //门店看板状态颜色及预警百分比 Metro 
    showStoreDashboardColor: false,
    percentageColorNum: {
        red: 5,
        green: 1,
    },

    //升级AP包大小限制
    upgradePackageSize: 200, //MB

    //barcode显示功能
    goodsBarcodeShow: false,
    bindingEslBarcodeShow: false,

    //搜索区域多选项最多提交个数值
    eslSearchFimwareCount: 10,
    bindSearchEslCount: 50,

    //重推任务周期执行显示
    repushCyclePeriod: false,

    //客户+门店看板页面配置按钮外链跳转
    externalLink: [],

    companyName: 'Hanshow',
    projectLogo: '',
    menuAttr: {},
    //logo src值
    menuLogo: '',

    //导入文件大小限制
    importFileSize: 2, //MB

    //ap 配置规则
    apwifiNameReg: /^[a-zA-Z0-9-]{1,32}$/,
    apwifiPdReg: /^[a-zA-Z0-9\-()~!@#$%^]{8,32}$/,

    //ext add limit
    extLinkNum: 10,

    //PRM-141 个人中心
    userCenterSwitch: true,

    //PRM-19 资产管理 
    storeAssetSize: [160, 230],

    //邮件收件人个数限制
    emailRecipientCount: 10,

    //邮件发送时间点个数限制
    emailTimeCount: 24,

    //临时处理接入qiankun的activeRule
    activeRule: '#/prismart',
    permissionMap: {
        //globalFirmware
        globalFirmware_retrieve: 'globalAfterSales_firmware_retrieve',
        globalFirmware_import: 'globalAfterSales_firmware_import',
        globalFirmware_delete: 'globalAfterSales_firmware_delete',
        //globalConfig
        globalConfig_retrieve: 'system_config_retrieve',
        globalConfig_update: 'system_config_update',
        globalConfig_him_retrieve: 'system_config_himRetrieve',
        globalConfig_him_update: 'system_config_himUpdate',
        globalConfig_captcha_retrieve: 'system_config_captchaSearch',
        globalConfig_captcha_update: 'system_config_captchaUpdate',
        globalConfig_rma_retrieve: 'system_config_rmaRetrieve',
        globalConfig_rma_update: 'system_config_rmaUpdate',
        globalConfig_ap_retrieve: 'system_config_happConfigRetrieve',
        globalConfig_ap_update: 'system_config_happConfigUpdate',
        globalConfig_env_update: 'system_config_webEnvironment',
        globalConfig_mfa_update: 'system_config_mfaGoogle',
        globalConfig_credential_update: 'system_config_credential',
        globalConfig_openLink_update: 'system_config_extraLink',
        //globalManagement
        globalManagement_search: 'customer_management_retrieve',
        globalManagement_add: 'customer_management_create',
        globalManagement_update: 'customer_management_update',
        globalManagement_editPassword: 'customer_management_updatePassword',
        globalManagement_nowaSetting: 'customer_management_nowa',
        globalManagement_restMfa: 'customer_management_resetGoogleMfa',
        globalManagement_unlock: 'customer_management_enableUser',
        //globalSeries
        globalSeries_search: 'globalAfterSales_productSeries_retrieve',
        globalSeries_add: 'globalAfterSales_productSeries_create',
        globalSeries_update: 'globalAfterSales_productSeries_update',
        globalSeries_delete: 'globalAfterSales_productSeries_delete',
        //globalApiAuth
        globalApi_retrieve: "system_apiAuth_retrieve",
        globalApi_update: "system_apiAuth_update",
        globalApi_reset: "system_apiAuth_reset",
        //globalLoginLog
        globalLoginLog_retrieve: "systemAuditLog_authLog_retrieve",
        globalLoginLog_export: "systemAuditLog_authLog_export",
        //globalBusinessLog
        globalBusinessLog_retrieve: "systemAuditLog_businessLog_retrieve",
        globalBusinessLog_export: "systemAuditLog_businessLog_export",
        //globalApModel
        globalApModel_retrieve: "globalAfterSales_apModel_retrieve",
        globalApModel_update: "globalAfterSales_apModel_update",

        //dashobard
        dashboard_normal_table: 'store_monitor_table',
        //custOrganizationManage
        custOrganizationManage_add: 'organization_organizationManage_create',
        custOrganizationManage_update: 'organization_organizationManage_update',
        custOrganizationManage_config: 'organization_organizationManage_config',
        custOrganizationManage_delete: 'organization_organizationManage_delete',
        //custStores
        custStores_add: 'organization_store_create',
        custStores_update: 'organization_store_update',
        custStores_checkEsl: 'organization_store_manualInputEslNum',
        custStores_configure: 'organization_store_config',
        custStores_management: 'organization_store_retrieve',
        custStores_teste: 'organization_store_retrieve',
        custStores_detail: 'organization_store_retrieve',
        custStores_setOrganization: 'organization_store_setOrganization',
        custStores_enable: 'organization_store_enable',
        custStores_disable: 'organization_store_disable',
        custStores_reportexport: 'organization_store_reportexport',
        custStores_exportBinding: 'organization_store_exportBinding',
        custStores_storeStatistics: 'organization_store_exportStoreStatistics',
        custStores_search: 'organization_store_retrieve',
        custStores_allowEsl: 'organization_store_allowEslConfig',
        custStores_delete: 'organization_store_delete',
        custStores_qrcode: 'organization_store_downloadQrcode',
        //custStoresMap
        custStoresMap_add: 'organization_storesMap_create',
        custStoresMap_update: 'organization_storesMap_update',
        custStoresMap_delete: 'organization_storesMap_delete',
        custStoresMap_see: 'organization_storesMap_view',
        //custStoreCheck
        custStoreCheck_inventoryAll: 'eslCheck_storeCheck_start',
        custStoreCheck_endInventoryAll: 'eslCheck_storeCheck_stop',
        custStoreCheck_exportAll: 'eslCheck_storeCheck_start',
        custStoreCheck_download: 'eslCheck_storeCheck_exportResult',
        custStoreCheck_inventoryReset: 'eslCheck_storeCheck_start',
        custStoreCheck_inventoryChose: 'eslCheck_storeCheck_start',
        custStoreCheck_endInventoryChose: 'eslCheck_storeCheck_stop',
        custStoreCheck_exportChose: 'eslCheck_storeCheck_exportResult',

        //custAllowEsl
        custAllowEsl_import: 'updateSearch_allowEsl_import',
        custAllowEsl_delete: 'updateSearch_allowEsl_delete',
        custAllowEsl_deleteImport: 'updateSearch_allowEsl_deleteImport',
        custAllowEsl_cleanEsl: 'updateSearch_allowEsl_cleanEsl',
        custAllowEsl_download: 'updateSearch_allowEsl_import',
        custAllowEsl_alleslable: 'updateSearch_allowEsl_config',
        custAllowEsl_init: 'updateSearch_allowEsl_init',
        custAllowEsl_initDetail: 'updateSearch_allowEsl_details',
        //custInfoSearchGoods
        custInfoSearchGoods_seeHistory: 'updateSearch_customerGoods_retrieve',
        custInfoSearchGoods_seeDetails: 'updateSearch_customerGoods_retrieve',

        //custUser
        custUser_add: 'auth_user_create',
        custUser_update: 'auth_user_update',
        custUser_delete: 'auth_user_delete',
        custUser_search: 'auth_user_retrieve',
        custUser_resetPassword: 'auth_user_resetPassword',
        custUser_editPassword: 'auth_user_resetPassword',
        custUser_restMfa: 'auth_user_resetGoogleMfa',
        custUser_unlock: 'auth_user_enable',
        //custRole
        custRole_add: 'auth_role_create',
        custRole_update: 'auth_role_update',
        custRole_delete: 'auth_role_delete',
        custRole_search: 'auth_role_retrieve',
        custRole_org: 'auth_role_organization',
        //custGoodsManage
        custGoodsManage_retrieve: "orgCdi_organizationGoods_retrieveGoods",
        custGoodsManage_update: "orgCdi_organizationGoods_modifyGoods",
        custGoodsManage_history: "orgCdi_organizationGoods_retrieveHistory",
        custGoodsManage_detail: "orgCdi_organizationGoods_retrieveStoreGoods",
        custGoodsManage_add: "orgCdi_organizationGoods_addGoods",
        //custUpdateRetrieval
        custUpdateRetrieval_start: 'updateSearch_retrieval_start',
        custUpdateRetrieval_reset: 'updateSearch_retrieval_reset',
        custUpdateRetrieval_download: 'updateSearch_retrieval_download',
        //custEmailConfig
        custEmailConfig_add: 'setting_emailConfig_create',
        custEmailConfig_update: 'setting_emailConfig_update',
        custEmailConfig_delete: 'setting_emailConfig_delete',
        custEmailConfig_assign: 'setting_emailConfig_assign',
        custEmailConfig_view: 'setting_emailConfig_retrieve',
        //custTimingUpdate
        custTimingUpdate_add: 'setting_timingUpdateEslStrategy_create',
        custTimingUpdate_update: 'setting_timingUpdateEslStrategy_update',
        custTimingUpdate_delete: 'setting_timingUpdateEslStrategy_delete',
        custTimingUpdate_enable: 'setting_timingUpdateEslStrategy_enable',
        custTimingUpdate_disable: 'setting_timingUpdateEslStrategy_disable',
        //custConfig
        custConfig_save: 'setting_customerConfig_update',
        //custEslAttrConfig
        custEslAttrConfig_add: 'setting_eslConfig_create',
        custEslAttrConfig_update: 'setting_eslConfig_update',
        custEslAttrConfig_delete: 'setting_eslConfig_delete',
        custEslAttrConfig_assign: 'setting_eslConfig_assign',
        custEslAttrConfig_send: 'setting_eslConfig_send',
        custEslAttrConfig_detail: 'setting_eslConfig_retrieve',
        //custReportConfig
        custReportConfig_save: 'report_config_updateConfig',
        custReportConfig_export: 'report_customer_export',

        //custTaskCycle
        custTaskCycle_add: 'task_timerGroup_create',
        custTaskCycle_update: 'task_timerGroup_update',
        custTaskCycle_delete: 'task_timerGroup_delete',
        custTaskCycle_assign: 'task_timerGroup_assign',
        custTaskCycle_management: 'task_timerGroup_retrieveStrategy',
        custTaskCycle_view: 'task_timerGroup_retrieve',
        //custTaskCycleDetial
        custTaskCycleDetial_addFlash: 'task_timerGroup_createFlashStrategy',
        custTaskCycleDetial_addPage: 'task_timerGroup_createPageStrategy',
        custTaskCycleDetial_refresh: 'task_timerGroup_createRefreshStrategy',
        custTaskCycleDetial_see: 'task_timerGroup_retrieveStrategy',
        custTaskCycleDetial_update: 'task_timerGroup_updateStrategy',
        custTaskCycleDetial_delete: 'task_timerGroup_deleteStrategy',
        custTaskCycleDetial_enable: 'task_timerGroup_switchStrategyStatus',
        custTaskCycleDetial_disable: 'task_timerGroup_switchStrategyStatus',
        custTaskCycleDetial_execute: 'task_timerGroup_executeStrategy',
        //custTaskRepush
        custTaskRepush_add: 'task_repushTask_create',
        custTaskRepush_update: 'task_repushTask_update',
        custTaskRepush_delete: 'task_repushTask_delete',
        custTaskRepush_assign: 'task_repushTask_assign',
        custTaskRepush_enable: 'task_repushTask_enable',
        custTaskRepush_disable: 'task_repushTask_disable',
        custTaskRepush_view: 'task_repushTask_retrieve',
        custTaskRepush_execute: 'task_repushTask_execute',
        //custTaskClean
        custTaskClean_retrieve: "task_dataClean_retrieve",
        custTaskClean_add: "task_dataClean_create",
        custTaskClean_update: "task_dataClean_update",
        custTaskClean_delete: "task_dataClean_delete",
        custTaskClean_enable: "task_dataClean_enable",
        custTaskClean_disable: "task_dataClean_disable",
        custTaskClean_execute: "task_dataClean_execute",
        custTaskClean_executeHistory: "task_dataClean_timerTaskHistory",

        //custDisabledGoods
        custDisabledGoods_retrieve: 'setting_goodsBlackList_retrieve',
        custDisabledGoods_add: 'setting_goodsBlackList_update',
        custDisabledGoods_delete: 'setting_goodsBlackList_delete',
        custDisabledGoods_batchdDlete: 'setting_goodsBlackList_delete',

        //custExportConfig
        custExportConfig_retrieve: 'setting_bindExportField_retrieve',
        custExportConfig_update: 'setting_bindExportField_create',


        //custStatisticsEsl
        custStatisticsEsl_retrieve: 'customerStatistics_abnormalEsl_retrieve',
        custStatisticsEsl_exportStatistic: 'customerStatistics_abnormalEsl_export',
        custStatisticsEsl_exportDetail: 'customerStatistics_abnormalEsl_exportDetails',

        //custStatisticsAp
        custStatisticsAp_retrieve: 'customerStatistics_statisticsAp_retrieve',
        custStatisticsAp_exportStatistic: 'customerStatistics_statisticsAp_export',
        custStatisticsAp_exportDetail: 'customerStatistics_statisticsAp_exportOffline',

        //custStatisticsDynamicEsl
        custDymEsl_retrieve: 'customerStatistics_statisticsDynamicEsl_retrieve',
        custDymEsl_exportDetail: 'customerStatistics_statisticsDynamicEsl_export',

        //custStatisticsAbStores
        custStaStore_retrieve: 'customerStatistics_customerAbnormalStore_retrieve',
        custStaStore_export: 'customerStatistics_customerAbnormalStore_export',

        //custStatisticsUsageEsl
        custStaUsageEsl_retrieve: 'customerStatistics_customerStoreEslUsage_retrieve',
        custStaUsageEsl_export: 'customerStatistics_customerStoreEslUsage_export',

        //custStatisticsAbBattery
        custStaAbBattery_retrieve: 'customerStatistics_customerStoreAbnormalBattery_retrieve',
        custStaAbBattery_export: 'customerStatistics_customerStoreAbnormalBattery_export',
        custStaAbBattery_exportDetail: 'customerStatistics_customerStoreAbnormalBattery_detailExport',

        //custStatisticsStore
        custStatisticsStore_retrieve: "customerStatistics_storeStatistics_search",

        //custStatisticMultiEsl
        custStatisticsMultiEsl_retrieve: "customerStatistics_multiEslGoodsStatistics_retrieve",
        custStatisticsMultiEsl_details: "customerStatistics_multiEslGoodsStatistics_details",

        //custMoveConfig
        custMoveConfig_retrieve: 'setting_moveConfig_retrieve',
        custMoveConfig_add: 'setting_moveConfig_create',
        custMoveConfig_update: 'setting_moveConfig_update',
        custMoveConfig_delete: 'setting_moveConfig_delete',

        //custTempCorrespondence
        custTepCorr_retrieve: 'setting_TemplateList_retrieve',
        custTepCorr_save: 'setting_TemplateList_save',
        custTepCorr_delete: 'setting_TemplateList_delete',
        custTepCorr_assign: 'setting_TemplateList_allocate',

        //custSystemConfig
        custSysConfig_retrieve: 'setting_systemConfig_retrieve',
        custSysConfig_deleteStore: 'setting_systemConfig_storeDeletionConfig',
        custSysConfig_nfcKey: 'setting_systemConfig_nfcCommunicationConfig',
        custSysConfig_SecurityKey: 'setting_systemConfig_userKeyConfig',
        custSysConfig_pageConfig: 'setting_systemConfig_eslSwitchPageTaskConfig',
        custSysConfig_handy: 'setting_systemConfig_pdaConfig',
        custSysConfig_limitEsl: 'setting_systemConfig_overLimitUsageESLConfig',
        custSysConfig_AbStoreConfig: 'setting_systemConfig_alarmStatisticsConfig',
        custSysConfig_solarConfig: "setting_systemConfig_solarBatteryConfig",
        custSysConfig_cancelFlash: "setting_systemConfig_cancelControlConfig",

        //custApBatchUpgrade
        custApUpgrade_retrieve: 'afterSales_customerApUpgrade_retrieve',
        custApUpgrade_upgrade: 'afterSales_customerApUpgrade_create',
        custApUpgrade_cancel: 'afterSales_customerApUpgrade_cancel',

        //custApList
        custApList_retrieve: 'apManagementSystem_apPro_retrieve',
        custApList_delete: 'apManagementSystem_apPro_delete',
        custApList_remove: 'apManagementSystem_apPro_unassign',
        custApList_export: 'apManagementSystem_apPro_export',
        custApList_config: 'apManagementSystem_apPro_updateConfig',
        custApList_reboot: 'apManagementSystem_apPro_reboot',
        custApList_assign: 'apManagementSystem_apPro_assignToStore',
        custApList_see: 'apManagementSystem_apPro_config',
        custApList_netConfig: 'apManagementSystem_apPro_configNetwork',
        custApList_viewLog: 'apManagementSystem_apPro_log',
        custApList_upload: 'apManagementSystem_apPro_logUpload',
        custApList_logDelete: 'apManagementSystem_apPro_logDelete',
        custApList_downlog: 'apManagementSystem_apPro_logDownload',
        custApList_resetpwd: 'apManagementSystem_apPro_passwdReset',
        custApList_updatepwd: 'apManagementSystem_apPro_passwdChange',
        custApList_changeId: 'apManagementSystem_apPro_changeId',
        custApList_replace: 'apManagementSystem_apPro_replace',
        custApList_v1Able: 'apManagementSystem_apPro_enableEslV1',
        custApList_offline: 'apManagementSystem_apPro_offline',
        // 掉线历史
        // custApList_uphistory: 'apManagementSystem_apPro_passwdChange',

        //custApVersion
        custApVersion_retrive: 'apManagementSystem_version_retrieve',
        custApVersion_add: 'apManagementSystem_version_upload',
        custApVersion_delete: 'apManagementSystem_version_delete',

        //custApUpgradePlan
        custApUpgradePlan_retrive: 'apManagementSystem_upgradePlan_retrieve',
        custApUpgradePlan_add: 'apManagementSystem_upgradePlan_create',
        custApUpgradePlan_delete: 'apManagementSystem_upgradePlan_delete',
        custApUpgradePlan_cancel: 'apManagementSystem_upgradePlan_cancel',

        //custApApp
        custApApp_retrive: 'apManagementSystem_app_retrieve',
        custApApp_see: 'apManagementSystem_app_detail',
        custApApp_restart: 'apManagementSystem_app_restart',
        custApApp_start: 'apManagementSystem_app_start',
        custApApp_stop: 'apManagementSystem_app_stop',
        custApApp_upgrade: 'apManagementSystem_app_upgrade',

        //custHummerManagement
        custHummerManagement_add: 'opsManagement_hummer_create',
        custHummerManagement_update: 'opsManagement_hummer_update',
        custHummerManagement_delete: 'opsManagement_hummer_delete',
        custHummerManagement_test: 'opsManagement_hummer_retrieve',
        custHummerManagement_assign: 'opsManagement_hummer_assign',
        custHummerManagement_detail: 'opsManagement_hummer_retrieve',
        custHummerManagement_import: 'opsManagement_hummer_import',

        //custHappAp
        custHappAp_retrieve: 'opsManagement_apMapping_retrieve',
        custHappAp_add: 'opsManagement_apMapping_create',
        custHappAp_update: 'opsManagement_apMapping_update',
        custHappAp_delete: 'opsManagement_apMapping_delete',
        custHappAp_import: 'opsManagement_apMapping_import',
        //custLoginLog
        custLoginLog_retrieve: "customerAuditLog_authLog_retrieve",
        custLoginLog_export: "customerAuditLog_authLog_export",
        //custBusinessLog
        custBusinessLog_retrieve: "customerAuditLog_businessLog_retrieve",
        custBusinessLog_export: "customerAuditLog_businessLog_export",
        //custTemplateManagement
        custTemplateProject_retrieve: "templateManagement_project_retrieve",
        custTemplateProject_delete: "templateManagement_project_delete",
        custTemplateProject_publish: "templateManagement_project_publish",
        //custTemplatePublishRecord
        custTemplatePublishRecord_retrieve: "templateManagement_publish_retrieve",
        custTemplatePublishRecord_add: "templateManagement_publish_create",
        custTemplatePublishRecord_update: "templateManagement_publish_update",
        custTemplatePublishRecord_delete: "templateManagement_publish_delete",
        custTemplatePublishRecord_cancel: "templateManagement_publish_cancel",
        //custAssetOfHeadquarters
        custAssetOfHeadquarters_retrieve: "asset_customerReport_retrieve",
        custAssetOfHeadquarters_export: "asset_customerReport_export",
        //custAssetOfStores
        custAssetOfStores_retrieve: "asset_storeReport_retrieve",
        custAssetOfStores_export: "asset_storeReport_export",
        //custAssetCurr
        custAssetCurr_retrieve: "asset_eslStatus_retrieve",
        custAssetCurr_export: "asset_eslStatus_export",
        //custAssetreceiptNo
        custAssetreceiptNo_retrieve: "asset_stockTake_retrieve",
        custAssetreceiptNo_stockIn: "asset_stockTake_stockIn",
        custAssetreceiptNo_stockOut: "asset_stockTake_stockOut",
        custAssetreceiptNo_repair: "asset_stockTake_repair",
        custAssetreceiptNo_export: "asset_stockTake_export",
        //custAssetConfigStore
        custAssetConfigStore_retrieve: "asset_store_retrieve",
        custAssetConfigStore_firstInstall: "asset_store_firstInstall",
        custAssetConfigStore_restock: "asset_store_restock",
        custAssetConfigStore_delete: "asset_store_delete",
        custAssetConfigStore_restockHistory: "asset_store_restockHistory",

        //custEmailTask
        custEmailTask_retrieve: "mailManagementV2_customerTask_retrieve",
        custEmailTask_create: "mailManagementV2_customerTask_create",
        custEmailTask_update: "mailManagementV2_customerTask_update",
        custEmailTask_delete: "mailManagementV2_customerTask_delete",
        custEmailTask_enable: "mailManagementV2_customerTask_enable",
        custEmailTask_disable: "mailManagementV2_customerTask_disable",
        custEmailTask_sendHistory: "mailManagementV2_customerTask_sendHistory",

        //custSenderConfig
        custSenderConfig_retrieve: "mailManagementV2_customerSender_retrieve",
        custSenderConfig_create: "mailManagementV2_customerSender_create",
        custSenderConfig_update: "mailManagementV2_customerSender_update",
        custSenderConfig_delete: "mailManagementV2_customerSender_delete",

        //custProfileConfig
        custProfileConfig_retrieve: "setting_profile_retrieve",
        custProfileConfig_update: "setting_profile_save",

        //storeEmailTask
        storeEmailTask_retrieve: "mailManagementV2_storeTask_retrieve",
        storeEmailTask_create: "mailManagementV2_storeTask_create",
        storeEmailTask_update: "mailManagementV2_storeTask_update",
        storeEmailTask_delete: "mailManagementV2_storeTask_delete",
        storeEmailTask_enable: "mailManagementV2_storeTask_enable",
        storeEmailTask_disable: "mailManagementV2_storeTask_disable",
        storeEmailTask_sendHistory: "mailManagementV2_storeTask_sendHistory",

        //storeSenderConfig
        storeSenderConfig_retrieve: "mailManagementV2_storeSender_retrieve",
        storeSenderConfig_update: "mailManagementV2_storeSender_update",

        //storeShortcutEsl
        storeShortcutEsl_retrieve: 'shortcut_esl_retrieve',
        storeShortcutEsl_import: 'shortcut_esl_import',
        storeShortcutEsl_export: 'shortcut_esl_export',
        storeShortcutEsl_delete: 'shortcut_esl_delete',
        storeShortcutEsl_unbind: 'shortcut_esl_unbind',
        storeShortcutEsl_flash: 'shortcut_esl_flashLight',
        storeShortcutEsl_bind: 'shortcut_esl_bind',
        storeShortcutEsl_detail: 'shortcut_esl_retrieve',
        storeShortcutEsl_enableTem: 'shortcut_esl_enableTemperature',
        storeShortcutEsl_disableTem: 'shortcut_esl_disableTemperature',
        storeShortcutEsl_getBattery: 'shortcut_esl_batterySync',
        storeShortcutEsl_batteryHistory: 'shortcut_esl_batteryTrend',
        //storeShortcutGoods
        storeShortcutGoods_add: 'shortcut_goods_create',
        storeShortcutGoods_import: 'shortcut_goods_import',
        storeShortcutGoods_export: 'shortcut_goods_export',
        storeShortcutGoods_delete: 'shortcut_goods_delete',
        storeShortcutGoods_unbind: 'shortcut_goods_unbind',
        storeShortcutGoods_update: 'shortcut_goods_update',
        storeShortcutGoods_bind: 'shortcut_goods_bind',
        storeShortcutGoods_see: 'shortcut_goods_retrieve',
        storeShortcutGoods_extraGoods: 'shortcut_goods_retrieve',
        storeShortcutGoods_deleteUnbind: 'shortcut_goods_deleteUnbindGoods',
        storeShortcutGoods_futureGood: 'shortcut_goods_futureGoodsRetrieve',
        //storeShortcutCustGoods
        storeShortcutCustGoods_add: 'shortcut_custGoods_create',
        storeShortcutCustGoods_import: 'shortcut_custGoods_import',
        storeShortcutCustGoods_export: 'shortcut_custGoods_export',
        storeShortcutCustGoods_DownloadTemplate: 'shortcut_custGoods_import',
        storeShortcutCustGoods_delete: 'shortcut_custGoods_delete',
        storeShortcutCustGoods_unbind: 'shortcut_custGoods_unbind',
        storeShortcutCustGoods_update: 'shortcut_custGoods_update',
        storeShortcutCustGoods_bind: 'shortcut_custGoods_bind',
        storeShortcutCustGoods_see: 'shortcut_custGoods_retrieve',
        //storeShortcutBindInfo
        storeShortcutBindInfo_retrieve: 'shortcut_binding_retrieve',
        storeShortcutBindInfo_repush: 'shortcut_binding_repush',
        storeShortcutBindInfo_export: 'shortcut_binding_export',
        storeShortcutBindInfo_importFlash: 'shortcut_binding_importFlashLight',
        storeShortcutBindInfo_resetDefaultPage: 'shortcut_binding_resetDefaultPage',
        storeShortcutBindInfo_repushSelected: 'shortcut_binding_repushSelected',
        storeShortcutBindInfo_unbind: 'shortcut_binding_unbind',
        storeShortcutBindInfo_flash: 'shortcut_binding_flashLight',
        storeShortcutBindInfo_getMspPartImage: 'shortcut_binding_getMspPartImage',
        storeShortcutBindInfo_getMspAllImage: 'shortcut_binding_getMspAllImage',
        storeShortcutBindInfo_switchPage: 'shortcut_binding_switchPage',
        storeShortcutBindInfo_importBind: 'shortcut_binding_importBinding',
        //storeShortcutEslUpdate
        storeShortcutEslUpdate_retrieve: 'shortcut_eslUpdateHistory_retrieve',
        storeShortcutEslUpdate_export: 'shortcut_eslUpdateHistory_export',

        //storeShortcutEsl
        storeShortcutUsedEsl_retrieve: 'shortcut_eslUsage_retrieve',
        storeShortcutUsedEsl_export: 'shortcut_eslUsage_export',

        //storeShortcutEslLog
        storeShortcutEslLog_retrieve: 'shortcut_eslOperationHistory_retrieve',
        storeShortcutEslLog_export: 'shortcut_eslOperationHistory_export',

        //storeInfoAp
        storeInfoAp_retrieve: 'store_ap_retrieve',
        storeInfoAp_delete: 'store_ap_delete',
        storeInfoAp_remove: 'store_ap_remove',
        storeInfoAp_ennableV1: 'store_ap_eanbleEslV1',
        storeInfoAp_disableV1: 'store_ap_disableEslV1',
        storeInfoAp_changeId: 'store_ap_changeId',
        storeInfoAp_assign: 'store_ap_assignStore',
        storeInfoAp_replace: 'store_ap_replace',
        storeInfoAp_export: 'store_ap_exportBind',
        //storeInfoMap
        storeInfoMap_see: 'store_storeMap_retrieve',
        //storeInfoEslCheck
        storeInfoEslCheck_download: 'store_eslCheck_downloadResult',
        //storeEslFailed

        storeEslFailed_retrieve: 'esl_failedList_retrieve',
        storeEslFailed_export: 'esl_failedList_export',
        storeEslFailed_unbind: 'esl_failedList_unbind',
        storeEslFailed_unbindAll: 'esl_failedList_unbindAll',
        //storeEslAllowEsl
        storeEslAllowEsl_downloadExample: 'esl_allowEsl_import',
        storeEslAllowEsl_import: 'esl_allowEsl_import',
        storeEslAllowEsl_export: 'esl_allowEsl_export',
        storeEslAllowEsl_delete: 'esl_allowEsl_delete',
        storeEslAllowEsl_deleteImport: 'esl_allowEsl_deleteImport',
        storeEslAllowEsl_clean: 'esl_allowEsl_cleanEsl',
        storeEslAllowEsl_init: 'esl_allowEsl_init',
        //storeLockedEsl
        storeEslDisallowEsl_import: 'esl_disallowEsl_import',
        storeEslDisallowEsl_delete: 'esl_disallowEsl_delete',
        storeEslDisallowEsl_deleteEsl: 'esl_disallowEsl_deleteEsl',
        storeEslDisallowEsl_unbind: 'esl_disallowEsl_unbind',
        //storeEslTemperature
        storeEslTemperature_update: 'temperatureCheck_temperature_remark',
        storeEslTemperature_delete: 'temperatureCheck_temperature_delete',
        storeEslTemperature_viewHistory: 'temperatureCheck_temperature_retrieve',
        storeEslTemperature_export: 'temperatureCheck_temperature_export',

        //storeSettingMailConfig
        storeSettingMailConfig_save: 'setting_mailConfig_controlSwitch',
        storeSettingMailConfig_test: 'setting_mailConfig_controlSwitch',
        //storeSettingSetWorConfig
        storeSettingSetWorConfig_save: "setting_changeSetWorStrategyV2_save",
        //storeSettingEslAttr
        storeSettingEslAttr_retrieve: 'setting_storeEslConfig_retrieve',
        storeSettingEslAttr_save: 'setting_storeEslConfig_save',
        storeSettingEslAttr_saveUpdate: 'setting_storeEslConfig_saveAndSend',
        storeSettingEslAttr_readOnly: 'setting_storeEslConfig_readOnly',
        storeSettingEslAttr_writeOnly: 'setting_storeEslConfig_writeOnly',
        storeSettingEslAttr_readAndWrite: 'setting_storeEslConfig_readAndWrite',

        //storeTaskCycle
        storeTaskCycle_search: 'storeTask_strategyV2_retrieve',
        storeTaskCycle_createFlash: 'storeTask_strategyV2_createFlash',
        storeTaskCycle_createPage: 'storeTask_strategyV2_createPage',
        storeTaskCycle_createRefresh: 'storeTask_strategyV2_createRefresh',
        storeTaskCycle_see: 'storeTask_strategyV2_retrieve',
        storeTaskCycle_update: 'storeTask_strategyV2_update',
        storeTaskCycle_delete: 'storeTask_strategyV2_delete',
        storeTaskCycle_enable: 'storeTask_strategyV2_enable',
        storeTaskCycle_disable: 'storeTask_strategyV2_disable',
        storeTaskCycle_execute: 'storeTask_strategyV2_execute',
        storeTaskCycle_executeResult: 'storeTask_strategyV2_timerTaskHistory',

        //storeTaskRepush
        storeTaskRepush_search: 'storeTask_repushTask_retrieve',
        storeTaskRepush_see: 'storeTask_repushTask_retrieve',
        storeTaskRepush_add: 'storeTask_repushTask_create',
        storeTaskRepush_update: 'storeTask_repushTask_update',
        storeTaskRepush_delete: 'storeTask_repushTask_delete',
        storeTaskRepush_enable: 'storeTask_repushTask_enable',
        storeTaskRepush_disable: 'storeTask_repushTask_disable',
        storeTaskRepush_execute: 'storeTask_repushTask_execute',
        storeTaskRepush_executeResult: 'storeTask_repushTask_timerTaskHistory',

        //storeTaskESLSwitchPageTask
        storeTaskEslSwitchPageTask_retrieve: "storeTask_eslSwitchPageTask_retrieve",
        storeTaskEslSwitchPageTask_delete: "storeTask_eslSwitchPageTask_delete",
        storeTaskEslSwitchPageTask_deleteAll: "storeTask_eslSwitchPageTask_delete",

        //storeReportList
        storeReportList_export: 'report_store_search',

        //storeVirtualEslManagement
        storeVirtualEslManagement_add: 'virtualEsl_virtualEsl_batchCreate',
        storeVirtualEslManagement_bind: 'virtualEsl_virtualEsl_bind',
        storeVirtualEslManagement_delete: 'virtualEsl_virtualEsl_batchDelete',
        storeVirtualEslManagement_deleteAll: 'virtualEsl_virtualEsl_deleteAll',

        //storeSettingMoveConfig
        storeSettingMoveConfig_retrieve: 'setting_storemoveConfig_retrieve',
        storeSettingMoveConfig_update: 'setting_storemoveConfig_update',
        storeSettingMoveConfig_undateSave: 'setting_storemoveConfig_saveAndSend',

        //storeApUpgradeHistory
        storeApUpgradeHistory_retrieve: 'afterSales_storeApUpgrade_retrieve',
        storeApUpgradeHistory_upgrade: 'afterSales_storeApUpgrade_create',

        //storeFailedEslReport
        storeFailedEslReport_export: 'reportCenter_notOkEsl_export',

        //storeAbnormalApReport
        storeAbnormalApReport_retrieve: 'reportCenter_abnormalAp_retrieve',

        //storeCommunicationReport
        storeCommunicationReport_unbind: 'reportCenter_timeoutEsl_unbind',
        storeCommunicationReport_export: 'reportCenter_timeoutEsl_export',

        //storeApList
        storeApList_retrieve: 'apManagement_apPro_retrieve',
        storeApList_delete: 'apManagement_apPro_delete',
        storeApList_remove: 'apManagement_apPro_unassign',
        storeApList_export: 'apManagement_apPro_export',
        storeApList_config: 'apManagement_apPro_updateConfig',
        storeApList_reboot: 'apManagement_apPro_reboot',
        storeApList_assign: 'apManagement_apPro_assignToStore',
        storeApList_see: 'apManagement_apPro_config',
        storeApList_netConfig: 'apManagement_apPro_configNetwork',
        storeApList_viewLog: 'apManagement_apPro_log',
        storeApList_upload: 'apManagement_apPro_logUpload',
        storeApList_logDelete: 'apManagement_apPro_logDelete',
        storeApList_downlog: 'apManagement_apPro_logDownload',
        storeApList_resetpwd: 'apManagement_apPro_passwdReset',
        storeApList_updatepwd: 'apManagement_apPro_passwdChange',
        storeApList_changeId: 'apManagement_apPro_changeId',
        storeApList_replace: 'apManagement_apPro_replace',
        storeApList_v1Able: 'apManagement_apPro_enableEslV1',
        storeApList_offline: "apManagement_apPro_offline",

        //storeApVersion
        storeApVersion_retrieve: 'apManagement_version_retrieve',
        storeApVersion_add: 'apManagement_version_upload',
        storeApVersion_delete: 'apManagement_version_delete',

        //storeApUpgradePlan
        storeApUpgradePlan_retrive: 'apManagement_upgradePlan_retrieve',
        storeApUpgradePlan_add: 'apManagement_upgradePlan_create',
        storeApUpgradePlan_delete: 'apManagement_upgradePlan_delete',
        storeApUpgradePlan_cancel: 'apManagement_upgradePlan_cancel',

        //storeShelfManage
        storeShelfManage_retrive: 'temperatureCheck_shelf_retrieve',
        storeShelfManage_add: 'temperatureCheck_shelf_create',
        storeShelfManage_update: 'temperatureCheck_shelf_update',
        storeShelfManage_delete: 'temperatureCheck_shelf_delete',
        storeShelfManage_import: 'temperatureCheck_shelf_createImport',
        storeShelfManage_config: 'temperatureCheck_shelf_temperatureConfig',
        storeShelfManage_history: 'temperatureCheck_shelf_temperatureHistory',
        storeShelfManage_alarm: 'temperatureCheck_shelf_alarmHistory',
        storeShelfManage_bind: 'temperatureCheck_shelf_bind',
        storeShelfManage_unbind: 'temperatureCheck_shelf_unbind',

        //orgEpdConfig
        orgEpdConfig: 'organization_organization_epdConfig,All-Star',

        //storeEpdConfig
        storeEpdConfig: 'organization_terminals_epdConfig,All-Star',
    },
};